import React from "react";
import OtpLogin from "./containers/OtpLogin";
import Authenticator from "./hoc/authenticator";
import WithLocation from "./hoc/withLocation";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

import "./App.scss";
import {
  SALON_DETAILS_ROUTE,
  SALON_CHECKOUT_ROUTE,
  SALON_ONBOARDING,
  VIEW_SERVICES,
  ADD_SERVICE,
  USER_HOME,
  EDIT_SERVICE,
  SALON_HOME,
  MY_BOOKINGS_SALON,
  FEEDBACK,
  ANALYTICS,
  REFERAL,
  ADD_EXPENSES,
  VIEW_EXPENSES,
  TERMS_CONDITION,
  PRIVACY_POLICY,
  NOTIFICATIONS,
  EDIT_EXPENSE,
  SIDEMENU,
  OTP_LOGIN,
  USER_ADDRESS,
  USER_ADDRESS_LIST,
  PROMO,
  VIEW_PROMO,
  EDIT_PROMO,
  TRY_ON,
  VIEW_BILL,
  OPEN_SALON,
  GENERATE_BILL,
} from "./constants";
import { parseJwt } from "./utils";
import GenerateBill from "./containers/GenerateBill";

const SalonDetails = React.lazy(() => import("./containers/SalonDetails"));
const Checkout = React.lazy(() => import("./containers/Checkout"));
const SalonOnboarding = React.lazy(() =>
  import("./containers/SalonOnboarding"),
);
const AddServices = React.lazy(() => import("./containers/AddServices"));
const TermsAndCondition = React.lazy(() =>
  import("./containers/TermsAndCondition"),
);
const PrivacyPolicy = React.lazy(() => import("./containers/PrivacyPolicy"));
const EditServices = React.lazy(() => import("./containers/EditServices"));
const SalonHome = React.lazy(() => import("./containers/SalonHome"));
const MySalonAppointments = React.lazy(() =>
  import("./containers/MySalonAppointments"),
);
const TryOn = React.lazy(() => import("./containers/TryOn"));
const Feedback = React.lazy(() => import("./containers/Feedback"));
const Analytics = React.lazy(() => import("./containers/Analytics"));
const Referal = React.lazy(() => import("./containers/Referal"));
const AddExpenses = React.lazy(() => import("./containers/AddExpenses"));
const ViewExpenses = React.lazy(() => import("./containers/ViewExpenses"));
const EditExpense = React.lazy(() => import("./containers/EditExpense"));
const ViewBill = React.lazy(() => import("./containers/ViewBill"));

const Notifications = React.lazy(() => import("./containers/Notifications"));
const SideMenu = React.lazy(() => import("./components/SideMenu"));
const UserAddress = React.lazy(() => import("./containers/Address"));
const UserAddressList = React.lazy(() => import("./containers/CurrentAddress"));

const PromoCodes = React.lazy(() => import("./containers/PromoCodes"));
const ViewPromoCodes = React.lazy(() => import("./containers/ViewPromoCodes"));
const EditPromoCodes = React.lazy(() => import("./containers/EditPromoCodes"));

function App() {
  const findFallbackfromLogin = () => {
    const { salon_id } = parseJwt() || {};
    if (salon_id) {
      return `${SALON_HOME}`;
    }
    return `${OTP_LOGIN}`;
  };

  const notify = () => toast.success(window.billMessage);

  return (
    <div className="App">
      <React.Suspense fallback={document.querySelector(".loaderElement")}>
        <div className="toastContainer">
          <button className="toastButton" onClick={notify}>
            Make me a toast
          </button>
          <Toaster />
        </div>
        <Router>
          <Switch>
            <Route exact path="/">
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={
                        findFallbackfromLogin() === `${SALON_HOME}` ? (
                          <SalonHome />
                        ) : (
                          <OtpLogin />
                        )
                      }
                      fallBackRoute={findFallbackfromLogin()}
                    />
                  }
                />
              }
            </Route>
            <Route exact path={OTP_LOGIN}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<OtpLogin />}
                      fallBackRoute={OTP_LOGIN}
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${SALON_DETAILS_ROUTE}/:id`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<SalonDetails />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={SALON_CHECKOUT_ROUTE}>
              {
                <WithLocation
                  component={
                    <Authenticator component={<Checkout />} fallBackRoute="/" />
                  }
                />
              }
            </Route>
            <Route exact path={`${SALON_ONBOARDING}/:step`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<SalonOnboarding />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${VIEW_SERVICES}/:id`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<SalonDetails />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${ADD_SERVICE}/:id`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<AddServices />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${EDIT_SERVICE}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<EditServices />}
                      fallBackRoute={USER_HOME}
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${PROMO}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<PromoCodes />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${VIEW_PROMO}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<ViewPromoCodes />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${EDIT_PROMO}/:id`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<EditPromoCodes />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${SALON_HOME}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<SalonHome />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${MY_BOOKINGS_SALON}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<MySalonAppointments />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${FEEDBACK}`}>
              {
                <WithLocation
                  component={
                    <Authenticator component={<Feedback />} fallBackRoute="/" />
                  }
                />
              }
            </Route>
            <Route exact path={`${TRY_ON}`}>
              {
                <WithLocation
                  component={
                    <Authenticator component={<TryOn />} fallBackRoute="/" />
                  }
                />
              }
            </Route>
            <Route exact path={`${ANALYTICS}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<Analytics />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${REFERAL}`}>
              {
                <WithLocation
                  component={
                    <Authenticator component={<Referal />} fallBackRoute="/" />
                  }
                />
              }
            </Route>
            <Route exact path={`${ADD_EXPENSES}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<AddExpenses />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${VIEW_BILL}/:id`}>
              {
                <WithLocation
                  component={
                    <Authenticator component={<ViewBill />} fallBackRoute="/" />
                  }
                />
              }
            </Route>
            <Route exact path={`${VIEW_EXPENSES}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<ViewExpenses />}
                      fallBackRoute="/"
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${TERMS_CONDITION}`}>
              <Authenticator
                component={<TermsAndCondition />}
                fallBackRoute={TERMS_CONDITION}
              />
            </Route>
            <Route exact path={`${PRIVACY_POLICY}`}>
              <Authenticator
                component={<PrivacyPolicy />}
                fallBackRoute={PRIVACY_POLICY}
              />
            </Route>
            <Route exact path={`${NOTIFICATIONS}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<Notifications />}
                      fallBackRoute={NOTIFICATIONS}
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${EDIT_EXPENSE}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<EditExpense />}
                      fallBackRoute={"/"}
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${SIDEMENU}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<SideMenu />}
                      fallBackRoute={"/"}
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${USER_ADDRESS}/:id?`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<UserAddress />}
                      fallBackRoute={"/"}
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${USER_ADDRESS_LIST}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<UserAddressList />}
                      fallBackRoute={"/"}
                    />
                  }
                />
              }
            </Route>
            <Route exact path={`${GENERATE_BILL}`}>
              {
                <WithLocation
                  component={
                    <Authenticator
                      component={<GenerateBill />}
                      fallBackRoute={"/"}
                    />
                  }
                />
              }
            </Route>
          </Switch>
        </Router>
      </React.Suspense>
    </div>
  );
}

export default App;
